import { OmitStrict } from '../../types';
import { objectEntries } from '../../utils';
import type { DropdownOption } from '../Dropdown';

import MultiSelectGroup, { MultiSelectGroupProps } from './MultiSelectGroup';

export type MultiSelectGroupListProps = OmitStrict<
  MultiSelectGroupProps,
  'options' | 'groupName'
> & {
  options: Record<string, DropdownOption[]>;
};

const MultiSelectGroupList: React.FC<MultiSelectGroupListProps> = ({
  options,
  ...rest
}) => (
  <>
    {objectEntries(options).map(
      ([groupName, data]) =>
        data?.length > 0 && (
          <MultiSelectGroup
            groupName={groupName}
            key={groupName}
            options={data}
            {...rest}
          />
        ),
    )}
  </>
);

export default MultiSelectGroupList;
